<template>
  <div>
    <div ref="box" class="pointer" style="width: 100%;height: 500px;background-color: #ffffff;"></div>
    <div class="text-right" style="margin-top: 10px;">
      <el-button @click="reset">重置</el-button>
      <el-button @click="submit" type="primary">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sign-canvas',
  components: {},
  props: [],
  data () {
    return {
      ctx: null,
      canvas: null,
      imgBase64: '',
      isDown: false
    }
  },
  async created () {
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.destroy()
      this.init()
    })
  },
  async beforeDestroy () {
    this.destroy()
  },
  computed: {},
  watch: {},
  methods: {
    destroy () {
      if (this.canvas) {
        window.document.removeEventListener('mouseup', this.touchstart, false)
        this.canvas.removeEventListener('touchstart', this.touchstart, false)
        this.canvas.removeEventListener('mousedown', this.mousedown, false)
        this.canvas.removeEventListener('touchmove', this.touchmove, false)
        this.canvas.removeEventListener('mousemove', this.mousemove, false)
        this.canvas.removeEventListener('touchend', this.touchend, false)
        this.$refs.box.innerHTML = ''
      }
    },
    init () {
      let box = this.$refs.box
      let canvas = window.document.createElement('canvas')
      box.appendChild(canvas)
      let ctx = canvas.getContext('2d')
      canvas.width = box.clientWidth
      canvas.height = box.clientHeight
      ctx.fillStyle = 'rgba(0, 0, 0, 0)'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      // ctx.globalAlpha = 0.9
      ctx.strokeStyle = '#000000'
      ctx.lineWidth = 4
      ctx.lineCap = 'round'
      canvas.addEventListener('touchstart', this.touchstart, false)
      canvas.addEventListener('mousedown', this.mousedown, false)
      canvas.addEventListener('touchmove', this.touchmove, false)
      canvas.addEventListener('mousemove', this.mousemove, false)
      canvas.addEventListener('touchend', this.touchend, false)
      window.document.addEventListener('mouseup', this.mouseup, false)
      this.ctx = ctx
      this.canvas = canvas
    },
    touchstart (e) {
      let x = e.changedTouches[0].pageX - e.target.offsetLeft
      let y = e.changedTouches[0].pageY - e.target.offsetTop
      this.ctx.beginPath()
      this.ctx.moveTo(x, y)
    },
    mousedown (e) {
      this.isDown = true
      let x = e.pageX - e.target.offsetLeft
      let y = e.pageY - e.target.offsetTop
      this.ctx.beginPath()
      this.ctx.moveTo(x, y)
    },
    touchmove (e) {
      let x = e.changedTouches[0].pageX - e.target.offsetLeft
      let y = e.changedTouches[0].pageY - e.target.offsetTop
      this.ctx.lineTo(x, y)
      this.ctx.stroke()
    },
    mousemove (e) {
      if (this.isDown) {
        let x = e.pageX - e.target.offsetLeft
        let y = e.pageY - e.target.offsetTop
        this.ctx.lineTo(x, y)
        this.ctx.stroke()
      }
    },
    touchend (e) {
      this.ctx.closePath()
      let imgBase64 = this.canvas.toDataURL()
      this.imgBase64 = imgBase64
    },
    mouseup (e) {
      if (this.isDown) {
        this.ctx.closePath()
        let imgBase64 = this.canvas.toDataURL()
        this.imgBase64 = imgBase64
        this.isDown = false
      }
    },
    reset () {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height)
    },
    async submit () {
      this.Tool.downloadFile(this.imgBase64, 'sign-' + Date.now() + '.png')
      console.log(this.imgBase64)
      let file = this.$HTTP.ApiOss.base64ToFile(this.imgBase64, 'sign')
      let url = await this.$HTTP.ApiOss.uploadOSS(file)
      console.log(url)
      this.$emit('change', url)
    }
  }
}
</script>
<style>
</style>
